export const Spinner = ({ text = '' }: { text?: string | null }) => {
  return (
    <div className="flex justify-center items-center mb-8">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      <span className="text-blue-500 font-semibold ml-2">{text}</span>
    </div>
  )
}
